"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Autocomplete.default;
  }
});
Object.defineProperty(exports, "createFilterOptions", {
  enumerable: true,
  get: function get() {
    return _Autocomplete.createFilterOptions;
  }
});

var _Autocomplete = _interopRequireWildcard(require("./Autocomplete"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/Autocomplete/index.js
// module id = 241
// module chunks = 0